import {productOrderService} from "../services/productOrderService";
import {productService} from "@/modules/products/services/productService.js";
import {
  paymentsService,
  paymentsStatusesService
} from "@/modules/payments/services";
import _ from 'lodash'
import Vue from 'vue'
import {matterService} from "../../matters/services/matterService";

const state = {
  productOrder: null,
  paymentStatus: null,
  originalProduct: null
}

const getters = {
  productOrder: (state) => state.productOrder,
  paymentStatus: (state) => state.paymentStatus,
  originalProduct: (state) => state.originalProduct
}

const mutations = {
  setProductOrder(state, productOrder) {
    state.productOrder = productOrder;
  },
  setOriginalProduct(state, product) {
    state.originalProduct = product;
  },
  setPaymentStatus(state, paymentStatus) {
    state.paymentStatus = paymentStatus;
  },
}

const actions = {
  async fetchProductOrder({commit, dispatch}, {payload}) {
    const {productOrderUid} = payload
    try {
      const res = await productOrderService.get(productOrderUid)
      commit('setProductOrder', res.data.product_order)
      return res.data
    } catch (e) {
      console.error('error', e);
    }
  },
  async fetchPaymentStatus({commit, dispatch}, {payload}) {
    const {paymentStatusUid} = payload
    try {
      const res = await paymentsStatusesService.get(paymentStatusUid)
      commit('setPaymentStatus', res.data)
      Vue.prototype.$frontageApi.send("set-payment-request-product-order", res.data);
      return res.data
    } catch(e) {
      console.error('error', error);
    }
  },
  async fetchOriginalProduct({commit, dispatch}, {payload}) {
    const {productUid} = payload;
    try {
      const res = await productService.show(productUid)
      commit('setOriginalProduct', res.data.product)
      return res.data
    } catch (e) {
      console.error('error', e);
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
